import { Fragment } from 'react/jsx-runtime';
import { useAddRepresentativesForm } from '../../hooks/useAddRepresentativesForm';
import { InputLabel, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
  AddRepresentativesFormField,
  AddRepresentativesWarningText,
} from '../AddRepresentativesModal/AddRepresentativesModal.styles';
import { memo } from 'react';
import { HandleSetFieldValueValueProps } from '../../model/AddRepresentativeSchema';

type AddRepresentativesFormListProps = {
  profile_type: string;
  representation_type: string;
  country: string;
  hasFreelance?: boolean;
  handleSetFieldValue: HandleSetFieldValueValueProps;
};

const showFreelanceText = (country: string, key: string) =>
  country === 'Australia' && key === 'Non-Represented' ? 'Freelance' : null;

const AddRepresentativesFormList = ({
  profile_type,
  representation_type,
  country,
  hasFreelance,
  handleSetFieldValue,
}: AddRepresentativesFormListProps) => {
  // This Hook contains the common representative form
  const { representatives_form } = useAddRepresentativesForm({
    profile_type,
    representation_type,
    country,
  });

  return (
    <Fragment>
      {representatives_form.map((form) => (
        <AddRepresentativesFormField key={form.key}>
          <InputLabel style={{ fontSize: 14 }}>{form.name}</InputLabel>
          <Autocomplete
            value={form.value}
            options={form.options}
            getOptionLabel={(option) => showFreelanceText(country, option.key) || option.key}
            getOptionSelected={(option, value) => (showFreelanceText(country, option.key) || option.key) === value.key}
            onChange={(_, newValue) => {
              handleSetFieldValue(form.key, newValue?.value || '');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select One"
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                }}
              />
            )}
          />
          {/* This Message only appears in Representation Type, if Non-Represented already exist, show this message */}
          {hasFreelance && form.key === 'representation_type' && representation_type === 'Non-Represented' ? (
            <AddRepresentativesWarningText>
              Only one {country === 'Australia' ? 'freelance' : 'personal'} profile is allowed.
            </AddRepresentativesWarningText>
          ) : null}
        </AddRepresentativesFormField>
      ))}
    </Fragment>
  );
};

export default memo(AddRepresentativesFormList);
